// src/config/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyBJ7zIA1wJNpmYz4rE92CPDndiYvLuhNlk',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'elpis-ae73c.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'elpis-ae73c',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'elpis-ae73c.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '840987211168',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:840987211168:web:3ca22aa66782ce0f7520c5',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-X8RBHBZFCF',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
